
import React, {useState, useContext, useEffect, useRef} from 'react';
import BooksForm from './BooksForm';
import { Button, Modal, Table, ButtonGroup, Dropdown } from 'react-bootstrap';
import { useSnackbar } from 'notistack';
import { ProductContext } from '../../ProductProvider';
import axios from 'axios';
import Preloader from '../../components/Preloader/Preloader';
import BooksPreview from './BooksPreview';
import {Helmet} from 'react-helmet-async';
import { fetchAuthSession } from 'aws-amplify/auth';
import { useReactToPrint } from "react-to-print";
import { CSVLink } from "react-csv";
import { downloaderBookinfo, books_category, bookCategory, bookClassification } from '../../ProData';
import AutoComplete from '../../components/AutoComplete';

const config = require('../../config.json');

// Modern UI styles for AddBooks page
const addBooksModernStyles = `
  .action-dropdown-menu .fa-eye {
    color: #4f8cff !important;
    font-size: 1.1em !important;
    min-width: 1.3em;
    display: inline-block;
  }
  .action-dropdown-menu .fa-pencil {
    color: #ffb300 !important;
    font-size: 1.1em !important;
    min-width: 1.3em;
    display: inline-block;
  }
  .action-dropdown-menu .fa-clone {
    color: #00b894 !important;
    font-size: 1.1em !important;
    min-width: 1.3em;
    display: inline-block;
  }
  .addbooks-section {
    background: linear-gradient(135deg, #f8fafc 0%, #e0e7ef 100%);
    min-height: 100vh;
    padding: 40px 0 60px 0;
    font-family: Inter, Segoe UI, Arial, sans-serif;
  }
  .addbooks-header {
    background: #fff;
    border-radius: 18px;
    box-shadow: 0 4px 16px 0 rgba(44, 62, 80, 0.08);
    padding: 2rem 1.5rem 1.5rem 1.5rem;
    margin-bottom: 2rem;
    text-align: center;
  }
  .addbooks-title {
    font-size: 2rem;
    font-weight: 700;
    color: #2a3659;
    margin-bottom: 0.5rem;
    letter-spacing: 0.5px;
  }
  .addbooks-btn {
    background: linear-gradient(90deg, #4f8cff 0%, #6ed0fa 100%);
    color: #fff !important;
    border: none !important;
    border-radius: 10px !important;
    padding: 10px 28px;
    font-size: 1.08rem;
    font-weight: 600;
    box-shadow: 0 2px 8px 0 rgba(44, 62, 80, 0.07);
    transition: background 0.2s, box-shadow 0.2s, transform 0.2s;
    margin-top: 10px;
    margin-bottom: 6px;
  }
  .addbooks-btn:hover, .addbooks-btn:focus {
    background: linear-gradient(90deg, #063547 60%, #7ee8fa 100%);
    color: #fff !important;
    transform: translateY(-2px) scale(1.03);
    box-shadow: 0 4px 16px 0 rgba(44, 62, 80, 0.13);
  }
  .addbooks-table {
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(44, 62, 80, 0.07);
    background: #fff;
    margin-bottom: 0;
  }
  .addbooks-table th, .addbooks-table td {
    font-size: 1rem;
    word-break: break-word;
    padding: 0.65rem 0.4rem;
    border-bottom: 1px solid #f1f3f4;
    background: #fff;
    transition: background 0.2s;
  }
  .addbooks-table th {
    text-align: center;
  }
  .addbooks-table td {
    text-align: left;
  }
  .addbooks-table th {
    background: #e3eafc !important;
    color: #2a3659;
    font-weight: 700;
    position: sticky;
    top: 0;
    z-index: 2;
    box-shadow: 0 2px 4px rgba(44, 62, 80, 0.04);
  }
  .addbooks-table tbody tr {
    transition: background 0.2s;
  }
  .addbooks-table tbody tr:hover {
    background: #f6fcff !important;
  }
  .addbooks-table tbody tr:nth-child(even) {
    background: #fafdff !important;
  }
  .addbooks-table .dropdown-toggle {
    color: #2a3659;
  }
  .addbooks-table .dropdown-menu {
    min-width: 140px;
    font-size: 1rem;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(44, 62, 80, 0.08);
  }
  @media (max-width: 900px) {
    .addbooks-table th, .addbooks-table td {
      font-size: 0.95rem;
      padding: 0.5rem 0.2rem;
    }
  }
  @media (max-width: 600px) {
    .addbooks-table th, .addbooks-table td {
      font-size: 0.9rem;
      padding: 0.4rem 0.1rem;
    }
    .addbooks-table {
      border-radius: 8px;
    }
  }
  .addbooks-search-form {
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 2px 8px rgba(44, 62, 80, 0.07);
    padding: 1.2rem 1rem 1rem 1rem;
    margin-bottom: 1.5rem;
  }
  .addbooks-search-form input, .addbooks-search-form select {
    border-radius: 8px !important;
    font-size: 1rem;
    padding: 7px 10px;
    border: 1px solid #e3eafc;
    margin-bottom: 0.5rem;
  }
  .addbooks-search-form .btn-box {
    margin-top: 0;
    padding: 7px 18px;
    font-size: 1rem;
    border-radius: 8px;
    background: linear-gradient(90deg, #4f8cff 0%, #6ed0fa 100%);
    color: #fff;
    border: none;
    font-weight: 600;
    transition: background 0.2s, box-shadow 0.2s, transform 0.2s;
  }
  .addbooks-search-form .btn-box:hover, .addbooks-search-form .btn-box:focus {
    background: linear-gradient(90deg, #063547 60%, #7ee8fa 100%);
    color: #fff;
    transform: translateY(-2px) scale(1.03);
    box-shadow: 0 4px 16px 0 rgba(44, 62, 80, 0.13);
  }
  @media (max-width: 900px) {
    .addbooks-section {
      padding: 20px 0 30px 0;
    }
    .addbooks-title {
      font-size: 1.3rem;
    }
    .addbooks-header {
      padding: 1.2rem 0.7rem 1rem 0.7rem;
    }
    .addbooks-btn {
      font-size: 1rem;
      padding: 8px 18px;
    }
    .addbooks-search-form {
      padding: 0.7rem 0.5rem 0.5rem 0.5rem;
    }
    .addbooks-table th, .addbooks-table td {
      font-size: 0.95rem;
      padding: 0.4rem 0.2rem;
    }
  }
  @media (max-width: 600px) {
    .addbooks-section {
      padding: 4px 0 10px 0;
    }
    .addbooks-title {
      font-size: 1rem;
      margin-bottom: 0.7rem;
    }
    .addbooks-header {
      border-radius: 8px;
      padding: 0.7rem 0.2rem 0.5rem 0.2rem;
    }
    .addbooks-btn {
      font-size: 0.95rem;
      padding: 7px 6px;
      border-radius: 7px;
      margin-top: 6px;
      width: 100%;
      max-width: 100%;
    }
    .addbooks-search-form {
      border-radius: 8px;
      padding: 0.5rem 0.1rem 0.3rem 0.1rem;
    }
    .addbooks-search-form input, .addbooks-search-form select {
      font-size: 0.95rem;
      padding: 6px 7px;
    }
    .addbooks-table th, .addbooks-table td {
      font-size: 0.9rem;
      padding: 0.3rem 0.1rem;
    }
  }
`;

export default function AddBooks() {
    const [bookDetails, setBookDetails] = useState({autoGenerate:true, Accession_No: "", Book_Author: "", bookCategory: "NA", Book_Classification_No: "", bookEdition: "", bookPages: "", bookPrice: "", Publishing_Year: "", Book_Publisher: "", Book_Scope: "Circulation", Book_Status: "Active", Book_Title: "", Tamil_Title:"", clientID: "", registeredOn: "", updatedBy: "", updatedOn: "",authorMark:"", bookCopies:1, bookPublisherLocation:"", bookSubTitle:"", bookKeywords:"", bookAbstract:"", bookDimension:"", isbn:"" });
    const [viewOnly, setViewOnly] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const { validateLogin, loggedUser, handleImageError, generateDate, generateAccessionNo } = useContext(ProductContext);
    const [loaded, setLoaded] = useState(true);
    const [searchResult, setSearchResult]=useState([]);
    const [searchValue, setSearchValue]= useState('');
    const [searchTopic, setSearchTopic]=useState('AccessionNo');
    const [dispMsg, setDispMsg] = useState('');
    const [show, setShow] = useState(false);
    const [formType, setFormType]=useState('View');
    const [modalTitle, setModalTitle] = useState('');
    const [imageFile, setImageFile] = useState('');
    const [profileImage, setProfileImage] = useState("images/cat1.png");
    const [newFileName, setNewFileName]=useState('');
    const csvLinkEl = React.createRef();
    const componentRef = React.useRef(null);
    const [categoryList, setCategoryList] = useState([]);
    const [userType, setUserType] = useState('');
    const [sorting, setSorting]=useState({field:"CallNo",order:"asc"});

    const [showScrollTop, setShowScrollTop] = useState(false);
    
const handleScroll = () => {
  if (window.scrollY > 200) {
    setShowScrollTop(true);
  } else {
    setShowScrollTop(false);
  }
};

useEffect(() => {
  window.addEventListener('scroll', handleScroll);
  return () => window.removeEventListener('scroll', handleScroll);
}, []);

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};


    useEffect(()=>{
        if(!loggedUser.isAuthenticated){
          validateLogin();
        }else{
            handleReset();
            const temp=books_category.filter((item)=>item.categoryDisplay==="Yes");
            setCategoryList(temp);
        }
      },[loggedUser])

    const handleNewSubmit=async(event)=>{
        event.preventDefault();
        setFormType('New');
        //console.log("book details", bookDetails);
        try{
            setLoaded(false);
            const validationResult=validateFields();
            //const validationResult="passed";
            const { idToken } = (await fetchAuthSession()).tokens ?? {};
            if(validationResult==="passed"){
                const {autoGenerate, Accession_No, Book_Author, bookCategory, Book_Classification_No, bookEdition, bookPages, bookPrice, Publishing_Year, Book_Publisher, Book_Scope, Book_Status, Book_Title, Tamil_Title, authorMark, bookCopies, bookPublisherLocation, bookSubTitle, bookKeywords, bookAbstract, bookDimension, isbn } = bookDetails;
                const todayDate=await generateDate();
                //console.log("Logged User : ", loggedUser);
                const params={
                    PK:"AKLibrary",
                    Accession_No:Accession_No,
                    autoGenerate:autoGenerate,
                    registeredOn:todayDate,
                    Book_Author:Book_Author,
                    bookCategory:bookCategory,
                    Book_Classification_No:Book_Classification_No,
                    bookEdition:bookEdition,
                    bookPages:bookPages,
                    bookPrice:bookPrice,
                    Publishing_Year:Publishing_Year,
                    Book_Publisher:Book_Publisher,
                    Book_Scope:Book_Scope,
                    Book_Status:Book_Status,
                    Book_Title:Book_Title,
                    Tamil_Title:Tamil_Title,
                    updatedOn:todayDate,
                    updatedBy:loggedUser.name,
                    authorMark:authorMark,
                    bookAbstract:bookAbstract,
                    bookKeywords:bookKeywords,
                    bookCopies:bookCopies,
                    bookPublisherLocation:bookPublisherLocation,
                    bookSubTitle:bookSubTitle,
                    bookDimension:bookDimension,
                    isbn:isbn
                };
               // console.log("Params : ", params);
                await axios.post(`${config.api.invokeUrl}/catalogue`,params, {  
                    headers: {
                      Authorization: idToken,
                      'x-api-key':config.api.key
                    }
                  }).then(async(response) => {
                 //     console.log("Response : ", response);
                      if(response.status===210){
                      setDispMsg(response.data);
                      enqueueSnackbar(response.data,{variant:'warning'});

                      }else{
                      if(imageFile)
                        {
                         postOnS3(Accession_No);
                        }     
                      setFormType("View");
                      setDispMsg(response.data);
                      handleClose();
                      handleReset();
                      enqueueSnackbar(response.data,{variant:'success'});
                      }
                      //handleReset();
                    setLoaded(true)
                    window.scrollTo(0,0);
                }).catch((error)=>{
                //console.log("Error : ", error);
                enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'});
                setLoaded(true);
                window.scrollTo(0,0);
              })
            }
        }catch(error){
            //console.log("Error : ", error);
            enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'});
        }
    }

    const handleEditSubmit=async(event)=>{
        event.preventDefault();
        //console.log("book details", bookDetails);
        try{
          setLoaded(false);
            const validationResult=validateFields();
            //const validationResult="passed";
            if(validationResult==="passed"){
                const {PK, Accession_No, Book_Author, registeredOn, bookCategory, Book_Classification_No, bookEdition, bookPages, bookPrice, Publishing_Year, Book_Publisher, Book_Scope, Book_Status, Book_Title, Tamil_Title, authorMark, bookCopies, bookPublisherLocation, bookSubTitle, bookKeywords, bookAbstract, bookDimension, isbn } = bookDetails;
                const todayDate=await generateDate();
                const { idToken } = (await fetchAuthSession()).tokens ?? {};
                //const tAccession_No=await generateAccessionNo();
                //console.log("Logged User : ", loggedUser);
                var tisbn=isbn;
                if(isbn===undefined){
                  tisbn="NA";
                }
                var tauthorMark=authorMark===undefined?"":authorMark;
                var tbookAbstract=bookAbstract===undefined?"":bookAbstract;
                var tbookCategory=bookCategory===undefined?"NA":bookCategory;
                var tbookCopies=bookCopies===undefined?"":bookCopies;
                var tbookDimension=bookDimension===undefined?"":bookDimension;
                var tbookEdition=bookEdition===undefined?"":bookEdition;
                var tbookKeywords=bookKeywords===undefined?"":bookKeywords;
                var tbookPages=bookPages===undefined?"":bookPages;
                var tbookPrice=bookPrice===undefined?"":bookPrice;
                var tbookSubTitle=bookSubTitle===undefined?"":bookSubTitle;
                var tregisteredOn=registeredOn===undefined?todayDate:registeredOn;
                var tbookPublisherLocation=bookPublisherLocation===undefined?"":bookPublisherLocation;
                var tbookTitle=Tamil_Title===undefined?"":Tamil_Title;
                const params={
                    PK:PK,
                    Accession_No:Accession_No,
                    registeredOn:tregisteredOn,
                    Book_Author:Book_Author,
                    bookCategory:tbookCategory,
                    Book_Classification_No:Book_Classification_No,
                    bookEdition:tbookEdition,
                    bookPages:tbookPages,
                    bookPrice:tbookPrice,
                    Publishing_Year:Publishing_Year,
                    Book_Publisher:Book_Publisher,
                    Book_Scope:Book_Scope,
                    Book_Status:Book_Status,
                    Book_Title:Book_Title,
                    Tamil_Title:tbookTitle,
                    updatedOn:todayDate,
                    updatedBy:loggedUser.name,
                    authorMark:tauthorMark,
                    bookAbstract:tbookAbstract,
                    bookKeywords:tbookKeywords,
                    bookCopies:tbookCopies,
                    bookPublisherLocation:tbookPublisherLocation,
                    bookSubTitle:tbookSubTitle,
                    bookDimension:tbookDimension,
                    isbn:tisbn
                };
                //console.log("Params : ", params);
                await axios.patch(`${config.api.invokeUrl}/catalogue`,params, {  
                    headers: {
                      Authorization: idToken,
                      'x-api-key':config.api.key
                    }
                  }).then(async(response) => {
                   //console.log("Response : ", response);
                   if(imageFile)
                   {
                    postOnS3(Accession_No);
                   }
                      enqueueSnackbar("Book Updated Successfully - " + Accession_No,{variant:'success'});
                      handleReset();
                     // handleSearch();
                      handleClose();
                    setLoaded(true)
                }).catch((error)=>{
                  //console.log("Error : ", error);
                enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'});
                setLoaded(true);
                window.scrollTo(0,0);
              })
            }
            setLoaded(true);
        }catch(error){
            //console.log("Error : ", error);
            setLoaded(true);
            enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'});
        }
    }

    const postOnS3 = async(taccessionNo)=>{
      //event.preventDefault();
      try{ 
          setLoaded(false);
          const { idToken } = (await fetchAuthSession()).tokens ?? {};
          const fileName=taccessionNo;
          const tnewFileName=fileName+".jpeg";
          const keyName='library/poster/';
  
          const bucketName=config.s3.bucketName; 
  
        var file = imageFile;
        var blob = file.slice(0, file.size, 'image/jpeg'); 
        const newFile = new File([blob], tnewFileName, {type: 'image/jpeg'});
        const fileType="image/jpeg";
        await axios.get(`${config.api.invokeURL}/vjlibrary/catalogue/poster?fileName=${tnewFileName}&bucketName=${bucketName}&fileType=${fileType}&keyName=${keyName}`,{
             headers:{
                Authorization: idToken,
                'x-api-key': config.api.key
             }
         }).then(async(response)=>{
             //console.log("Response : ", response);
             await fetch(response.data.uploadURL, { method: 'PUT',
             headers:{
                 "Content-Type":"image/jpeg"
               },body: newFile})
               .then(async(res)=>{
               //console.log("Res : ", res);
               if(res.status===200){
                  //fetchGalleryImages();
                   setProfileImage(newFileName);
                  // var tprofile = document.getElementById("profile");
                  // tprofile.src="https://s3.ap-south-1.amazonaws.com/idntica.com/avatar/profileImage/defaultAvatar.jpeg";
                   //toggle();
               }
              }).catch((error)=>{
                  //console.log("Error :", error);
                  enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'});
                  setLoaded(true);
                  window.scrollTo(0,0);   
             })
          }).catch((error)=>{
              //console.log("Error :", error);
              enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'});
              setLoaded(true);
              window.scrollTo(0,0);   
         })
      
      }catch(error){
        //console.log("Error :", error);
        enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'});
        setLoaded(true);
        window.scrollTo(0,0);   
      }
      setLoaded(true);
      }

    const handlePreviewView=(event)=>{
      event.preventDefault();
      const validationResult=validateFields();
      if(validationResult==="passed"){
      setFormType("Preview");
      setModalTitle('Add a Book');     
      setViewOnly(true);
      }
    }

    const validateFields=()=>{
        var returnValue="passed";
        const {autoGenerate, Accession_No, Book_Author, Book_Classification_No, authorMark, bookCopies, bookPublisherLocation, bookSubTitle, bookPages, bookPrice, Publishing_Year, Book_Publisher, Book_Scope, Book_Status, Book_Title, bookKeywords } = bookDetails;
        //console.log(autoGenerate,bookCopies,formType);
        if(!autoGenerate && Accession_No===""){
          enqueueSnackbar("Accession No is mandatory.",{variant : 'info'});
          returnValue="failed";
        }else if((!autoGenerate || autoGenerate!=undefined ) && bookCopies > 2 && formType==="New"){
            enqueueSnackbar("Book Copies cannot be more than 1 for Input Accession No",{variant : 'info'});
            returnValue="failed";
        }else if(Book_Author===""){
          enqueueSnackbar("Author is mandatory.",{variant : 'info'});
          returnValue="failed";
        }else if(Book_Classification_No===""){
          enqueueSnackbar("Book Classification Number is mandatory.",{variant : 'info'});
          returnValue="failed";
        }else if(authorMark===""){
          enqueueSnackbar("Author Mark is mandatory!.",{variant : 'info'});
          returnValue="failed";
        }/*else if(bookPages===""){
          enqueueSnackbar("Book Pages is mandatory!",{variant : 'info'});
          returnValue="failed";
        }else if(bookPrice===""){
            enqueueSnackbar("Book Price is mandatory!",{variant : 'info'});
            returnValue="failed";
        }else if(Book_Publisher===""){
            enqueueSnackbar("Book Publisher is mandatory!",{variant : 'info'});
            returnValue="failed";
        }else if(Publishing_Year===""){
            enqueueSnackbar("Book Publish Year is mandatory!",{variant : 'info'});
            returnValue="failed";
        }*/else if(Book_Title===""){
            enqueueSnackbar("Book Title is mandatory!",{variant : 'info'});
            returnValue="failed";
        }else if(Book_Status===""){
            enqueueSnackbar("Book Status is mandatory!",{variant : 'info'});
            returnValue="failed";
        }/*else if(Book_Scope===""){
            enqueueSnackbar("Book Scope is mandatory!",{variant : 'info'});
            returnValue="failed";
        }else if(bookCopies===""){
          enqueueSnackbar("Book Copies is mandatory!",{variant : 'info'});
          returnValue="failed";
      }else if(bookPublisherLocation===""){
        enqueueSnackbar("Book Publisher Location is mandatory!",{variant : 'info'});
        returnValue="failed";
    }else if(bookSubTitle===""){
      enqueueSnackbar("Book Sub Title is mandatory!",{variant : 'info'});
      returnValue="failed";
  }*/else if(bookCopies>10){
    enqueueSnackbar("Can add only maximum 10 copies at a time!",{variant : 'info'});
    returnValue="failed";
}/*else if(bookKeywords===""){
  enqueueSnackbar("Keywords cannot be empty",{variant : 'info'});
  returnValue="failed";
}*/else {
      returnValue="passed";
      }
    return returnValue;
    }
  
    const handleReset=async()=>{
        //event.preventDefault();
        const taccessionNo=await generateAccessionNo();
        setBookDetails({...bookDetails, autoGenerate:true, Accession_No: taccessionNo, Book_Author: "", bookCategory: "NA", Book_Classification_No: "", bookEdition: "", bookPages: "", bookPrice: "", Publishing_Year: "", Book_Publisher: "", Book_Scope: "Circulation", Book_Status: "Active", Book_Title: "", Tamil_Title:"", clientID: "", registeredOn: "", updatedBy: "", updatedOn: "",authorMark:"", bookCopies:1, bookPublisherLocation:"", bookSubTitle:"", bookKeywords:"", bookAbstract:"", bookDimension:"", isbn:"" });
        setDispMsg('');
        setImageFile('');
        setProfileImage("images/cat1.png");
    }

    const handleSearch=async(event)=>{
        event.preventDefault();
        try{
          if(searchValue===""){
            enqueueSnackbar('Search Input cannot be empty!',{variant:'info'}); 
          }else{
            setLoaded(false);
            setDispMsg('');
            const { idToken } = (await fetchAuthSession()).tokens ?? {};
            var keysearchValue="";
            if(searchTopic==="BookCategory"){
              keysearchValue=searchValue;
            }else{
              keysearchValue=searchValue.toUpperCase();
            }

            //const clientID="AKL";
            //await axios.get(`${config.api.invokeUrl}/search/books?fetchKey=${searchValue}&fetchOption=${searchTopic}&clientID=${clientID}`, {
            await axios.get(`${config.api.invokeUrl}/search/books?fetchKey=${keysearchValue}&fetchOption=${searchTopic}&clientID=${loggedUser.family_name}`,{
              headers: {
              Authorization: idToken,
             'x-api-key':config.api.key
            }
          }).then(async(response) => {
           //console.log("response : ", response.data);
           setDispMsg(response.data.length+' - Books Found');
              setSearchResult(response.data);
            enqueueSnackbar(response.data.length+' - Books Found',{variant:'success'}); 
            setLoaded(true);
        }).catch((error)=>{
          enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
        setLoaded(true);
        
      })
    }
        }catch(error){
            //console.log("error:", error);
            enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});

        }
    }

    const handleClose = () => {
      setImageFile('');
      setShow(false);
    }

    const handleShow = (event, mode, item) => {
      event.preventDefault();
      setFormType(mode);
      if(mode==="View"){
        setViewOnly(true);
        setBookDetails(item);
        setModalTitle('View Book - '+item.Accession_No);  
        const tImageName=item.Accession_No+".jpeg";
        setProfileImage(`${config.s3.bookPoster}${tImageName}`);
        setFormType("View");
      //  console.log("Profile Image : ",`${config.s3.bookPoster}${tImageName}` );
        //setProfileImage('https://s3.ap-south-1.amazonaws.com/images.vidyajyoticollege.in/library/poster/158546.jpeg');   
      }else if(mode==="Edit"){
        setViewOnly(false);
        setBookDetails(item);
        setModalTitle('Edit Book - '+item.Accession_No); 
        const tImageName=item.Accession_No+".jpeg";
        setProfileImage(`${config.s3.bookPoster}${tImageName}`);
                setFormType("Edit");
       // console.log("Profile Image : ",`${config.s3.bookPoster}${tImageName}` );    
      }else if(mode==="New"){
        //setBookDetails({...bookDetails, autoGenerate:true});
        handleReset();
        setViewOnly(false);
        setModalTitle('Add a Book');  
        setFormType("New");   
      }else if(mode==="Clone"){
        setViewOnly(false);
        item.Accession_No="";
        setBookDetails(item);
        setModalTitle('Clone Book - '+item.Accession_No);   
        setFormType('Clone');  
      }
      setShow(true);
    }

    const handleGoBack=(event)=>{
      event.preventDefault();
      setFormType("New");
      setModalTitle('Preview - Book Details');
      setViewOnly(false);
    }

    const handleDownload =async(event)=>{
      event.preventDefault();
      csvLinkEl.current.link.click();
    }

    const printFn = useReactToPrint({
      contentRef: componentRef,
      documentTitle: "Flynn Library",
    });

    const processSelection=(ivalue)=>{
      //console.log("ivalue:", ivalue);
      if(ivalue){
      if(searchTopic==="BookCategory"){
        setSearchValue(ivalue.svalue);
      }else if(searchTopic==="BookClassification"){
        setSearchValue(ivalue.value);
      }else{
        setSearchValue(ivalue.name);
      }
    }else{
      setSearchValue(userType);
    }
    }

    const handleSortKey =async(event, value, order)=>{
     // event.preventDefault();
      if(value==="Accession_No" && order==="asc"){
        const tempOrginalValue=searchResult;
        //setBookResult([]);
        //const tempFilterValue=tempOrginalValue.sort((a,b)=>)
        var sortedOptionArray = tempOrginalValue.sort((a, b) => {return a.Accession_No - b.Accession_No;});
        await setSearchResult(sortedOptionArray);
        setSorting({field:"AccessionNo",order:"asc"});
      }else if(value==="AccessionNo" && order==="desc"){
        const tempOrginalValue=searchResult;
        //setBookResult([]);
        //const tempFilterValue=tempOrginalValue.sort((a,b)=>)
        sortedOptionArray = tempOrginalValue.sort((a, b) => {return b.Accession_No - a.Accession_No});
        await setSearchResult(sortedOptionArray);
        setSorting({field:"AccessionNo",order:"desc"});
      }else if(value==="BookTitle" && order==="asc"){
        const tempOrginalValue=searchResult;
        //const tempFilterValue=tempOrginalValue.sort((a,b)=>)
        sortedOptionArray = tempOrginalValue.sort((a, b) => {
          if (a.Book_Title < b.Book_Title) {
            return 1;
          }
          if (a.Book_Title > b.Book_Title) {
            return -1;
          }
          return 0;
        });
        setSorting({field:"BookTitle",order:"asc"});
        await setSearchResult(sortedOptionArray);
      }else if(value==="BookTitle" && order==="desc"){
        const tempOrginalValue=searchResult;
        //const tempFilterValue=tempOrginalValue.sort((a,b)=>)
          sortedOptionArray = tempOrginalValue.sort((a, b) => {
            if (a.Book_Title < b.Book_Title) {
              return -1;
            }
            if (a.Book_Title > b.Book_Title) {
              return 1;
            }
            return 0;
          }); 
        setSorting({field:"BookTitle",order:"desc"});
        await setSearchResult(sortedOptionArray);
      }else if(value==="BookAuthor" && order==="asc"){
        const tempOrginalValue=searchResult;
        //const tempFilterValue=tempOrginalValue.sort((a,b)=>)
        sortedOptionArray = tempOrginalValue.sort((a, b) => {
          if (a.Book_Author < b.Book_Author) {
            return 1;
          }
          if (a.Book_Author > b.Book_Author) {
            return -1;
          }
          return 0;
        });
        setSorting({field:"BookAuthor",order:"asc"});
        await setSearchResult(sortedOptionArray);
      }else if(value==="BookAuthor" && order==="desc"){
        const tempOrginalValue=searchResult;
        //const tempFilterValue=tempOrginalValue.sort((a,b)=>)
        sortedOptionArray = tempOrginalValue.sort((a, b) => {
            if (a.Book_Author < b.Book_Author) {
              return -1;
            }
            if (a.Book_Author > b.Book_Author) {
              return 1;
            }
            return 0;
          }); 
        setSorting({field:"BookAuthor",order:"desc"});
        await setSearchResult(sortedOptionArray);
      }else if(value==="IssuedTo" && order==="asc"){
        const tempOrginalValue=searchResult;
        //const tempFilterValue=tempOrginalValue.sort((a,b)=>)
        sortedOptionArray = tempOrginalValue.sort((a, b) => {
          if (a.bookedfor < b.bookedfor) {
            return 1;
          }
          if (a.bookedfor > b.bookedfor) {
            return -1;
          }
          return 0;
        });
        setSorting({field:"IssuedTo",order:"asc"});
        await setSearchResult(sortedOptionArray);
      }else if(value==="IssuedTo" && order==="desc"){
        const tempOrginalValue=searchResult;
        //const tempFilterValue=tempOrginalValue.sort((a,b)=>)
          sortedOptionArray = tempOrginalValue.sort((a, b) => {
            if (a.bookedfor < b.bookedfor) {
              return -1;
            }
            if (a.bookedfor > b.bookedfor) {
              return 1;
            }
            return 0;
          }); 
        setSorting({field:"IssuedTo",order:"desc"});
        await setSearchResult(sortedOptionArray);
      }else if(value==="CallNo" && order==="asc"){
        const tempOrginalValue=searchResult;
        //const tempFilterValue=tempOrginalValue.sort((a,b)=>)
        sortedOptionArray = tempOrginalValue.sort((a, b) => {
          if (a.Book_Classification_No < b.Book_Classification_No) {
            return 1;
          }
          if (a.Book_Classification_No > b.Book_Classification_No) {
            return -1;
          }
          return 0;
        });
        setSorting({field:"CallNo",order:"asc"});
        await setSearchResult(sortedOptionArray);
      }else if(value==="CallNo" && order==="desc"){
        const tempOrginalValue=searchResult;
        //const tempFilterValue=tempOrginalValue.sort((a,b)=>)
          sortedOptionArray = tempOrginalValue.sort((a, b) => {
            if (a.Book_Classification_No < b.Book_Classification_No) {
              return -1;
            }
            if (a.Book_Classification_No > b.Book_Classification_No) {
              return 1;
            }
            return 0;
          }); 
        setSorting({field:"CallNo",order:"desc"});
        await setSearchResult(sortedOptionArray);
      }
    }

  return (
    <>
    <Helmet>
      <title>Manage Books - Inigo Library - Arul Kadal - Chennai</title>
      <meta name="description" content="Manage Books - Inigo Library - Arul Kadal - Chennai" />
      <meta name="keywords" content="Manage Books - Inigo Library - Arul Kadal - Chennai" /> 
    </Helmet>

    <Modal show={show} onHide={handleClose} size='xl' >
        <Modal.Header closeButton>
        <Modal.Title>{modalTitle} </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        
        {formType==="Preview" ? <BooksPreview bookDetails={bookDetails} setBookDetails={setBookDetails} viewOnly={viewOnly} handleClose={handleClose} dispMsg={dispMsg}/>
        :<BooksForm bookDetails={bookDetails} setBookDetails={setBookDetails} viewOnly={viewOnly} handleClose={handleClose} formType={formType} dispMsg={dispMsg} 
        setNewFileName={setNewFileName} setImageFile={setImageFile} profileImage={profileImage}/>}
        <div className="mt-3 text-center">
            {formType==="New" || formType==="Clone" ?<button variant="primary" className='btn-box' type="submit" onClick={(event)=>{handlePreviewView(event)}}> Preview</button>
            :formType==="Preview"?<button variant="primary" className='btn-box' type="submit" onClick={(event)=>{handleNewSubmit(event)}}> Save</button>
            :formType==="Edit"?<button variant="primary" className='btn-box' type="submit" onClick={(event)=>{handleEditSubmit(event)}}> Update</button>:null}
            {"      "}
            <button variant="primary" className='btn-box' type="submit" onClick={(event)=>{handleClose()}}>Close</button>
            {"      "}
            {formType==="Preview" && <button variant="primary" className='btn-box' type="submit" onClick={(event)=>{handleGoBack(event)}}> Go Back</button>}
        </div>   
        </Modal.Body>
    </Modal>

    <div className="addbooks-section container-fluid" style={{paddingTop:0}}>
      <style>{addBooksModernStyles}
      {`
         /* Responsive header action row */
        @media (max-width: 767.98px) {
          .addbooks-header-action-row {
            flex-direction: column !important;
            align-items: stretch !important;
            gap: 0.5rem !important;
          }
          .addbooks-header-action-row > div {
            width: 100% !important;
            margin-bottom: 0.5rem !important;
          }
          .addbooks-header-action-row .btn-toolbar {
            justify-content: flex-start !important;
            margin-bottom: 0 !important;
          }
        }
        @media (max-width: 600px) {
          .addbooks-header {
            padding: 0.7rem 0.2rem 0.5rem 0.2rem;
          }
          .addbooks-title {
            font-size: 1.1rem;
          }
          .addbooks-btn {
            font-size: 0.98rem;
            padding: 7px 6px;
            border-radius: 7px;
            margin-top: 6px;
            width: 100%;
            max-width: 100%;
          }
          .addbooks-search-form {
            border-radius: 8px;
            padding: 0.5rem 0.1rem 0.3rem 0.1rem;
          }
          .addbooks-search-form input, .addbooks-search-form select {
            font-size: 0.95rem;
            padding: 6px 7px;
          }
        }
      `}</style>
              {!loaded && <Preloader show={loaded ? false : true} />}
      
      <section className="search_section container">

        <form action="#" className="addbooks-search-form">
          <div className="row g-3">
      <div className="addbooks-header">
        <div className="addbooks-title">Manage your Book's</div>
        
      </div>
      <div className="d-flex flex-wrap flex-md-nowrap align-items-center gap-2 mt-2 mb-2 addbooks-header-action-row" style={{minHeight: 56}}>
        <div className="d-flex align-items-center flex-shrink-0 addbooks-header-action-btn" style={{height: '100%'}}>
          <button type="button" className="addbooks-btn w-100" style={{marginBottom: 0, marginTop: 0, height: 44}} onClick={event=>handleShow(event, "New")}> <i className="fa fa-plus" aria-hidden="true"></i> New</button>
        </div>
        <div className="flex-grow-1 d-none d-md-block"></div>
        <div className="btn-toolbar d-flex align-items-center flex-shrink-1 addbooks-header-action-icons mb-2 mb-md-0" style={{height: '100%'}}>
          <ButtonGroup>
            <Button variant="outline-primary" size="sm" style={{height: 40, display: 'flex', alignItems: 'center', width: '48px', justifyContent: 'center'}} onClick={printFn} title="Print">
              <i className="fa fa-print" aria-hidden="true"></i>
            </Button>
            <Button variant="outline-primary" size="sm" style={{height: 40, display: 'flex', alignItems: 'center', width: '48px', justifyContent: 'center'}} onClick={(event)=>{handleDownload(event)}} title="Download CSV">
              <i className="fa fa-download" aria-hidden="true"></i>
            </Button>
            <CSVLink
              headers={downloaderBookinfo}
              filename="download.csv"
              data={searchResult}
              ref={csvLinkEl}
            />
          </ButtonGroup>
        </div>
      </div>
            <div className="col-12 col-md-3 d-flex align-items-center mb-2 mb-md-0" style={{height: '48px'}}>
              <select name="searchOption" id="bookSearch"
                className="form-select w-100 h-100"
                style={{minHeight: '44px', height: '100%'}}
                value={searchTopic}
                onChange={event=>setSearchTopic(event.target.value)}>
                <option value="AccessionNo">Book ID</option>
                <option value="BookTitle">Book Title</option>
                <option value="BookAuthor">Author</option>
                {/*<option value="Call No">Call No</option>
                <option value="BookCategory">Category</option>*/}
                <option value="BookClassification">Classification</option>
                <option value="BookPublisher">Publisher</option>
                <option value="PublishingYear">Publish Year</option>
              </select>
            </div>
            <div className="col-12 col-md-7 d-flex align-items-center mb-2 mb-md-0" style={{height: '48px'}}>
              {searchTopic==="BookCategory" ? (
                <div className="w-100 h-100 d-flex align-items-center">
                  <AutoComplete
                    data={bookCategory}
                    onSelect={country => processSelection(country)}
                    style={{width: '100%', height: '100%'}}
                  />
                </div>
              )  :searchTopic==="BookClassification" ? (
              <div className="col-12 col-md-6">
                <AutoComplete
                  data={bookClassification}
                  onSelect={country => processSelection(country)}
                />
              </div>
            ): (
                <input type="text" className="form-control w-100 h-100" style={{minHeight: '44px', height: '100%'}} placeholder="" onChange={event=>setSearchValue(event.target.value)}/>
              )}
            </div>
            <div className="col-12 col-md-2 d-flex align-items-center mb-2 mb-md-0" style={{height: '48px'}}>
              <button type="submit" id="form-submit" className='addbooks-btn w-100 h-100' style={{minHeight: '44px', height: '100%'}} onClick={event=>handleSearch(event)}>
                <i className="fa fa-search" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </form>
      </section>
      <div className="col-md-6 container">
        <h4>{dispMsg}</h4>
      </div>
      <div className="container mt-2 " style={{paddingBottom: '100px'}}>
        {searchResult.length>0?
          <Table hover responsive ref={componentRef} className="addbooks-table" style={{marginBottom: '100px', minHeight: '300px'}}>
            <thead>
              <tr>
                <th>#</th>
                <th>
                  <span>Accession No</span>
                  <button type="button" className="sort-btn ms-1" title="Sort by Accession No"
                    onClick={event => handleSortKey(event, "AccessionNo", sorting.field === "AccessionNo" && sorting.order === "asc" ? "desc" : "asc")}
                    style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', verticalAlign: 'middle' }}>
                    <i className={
                      sorting.field === "AccessionNo"
                         && sorting.order === "asc"
                            ? "fa fa-arrow-up text-primary"
                            : "fa fa-arrow-down text-primary"
                    }
                    style={{ fontSize: '1.1em', opacity: sorting.field === "AccessionNo" ? 1 : 0.7 }}></i>
                  </button>
                </th>
                <th>
                  <span>Book Title</span>
                  <button type="button" className="sort-btn ms-1" title="Sort by Book Title"
                    onClick={event => handleSortKey(event, "BookTitle", sorting.field === "BookTitle" && sorting.order === "asc" ? "desc" : "asc")}
                    style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', verticalAlign: 'middle' }}>
                    <i className={
                      sorting.field === "BookTitle"
                        && sorting.order === "asc"
                            ? "fa fa-arrow-up text-primary"
                            : "fa fa-arrow-down text-primary"
                    }
                    style={{ fontSize: '1.1em', opacity: sorting.field === "BookTitle" ? 1 : 0.7 }}></i>
                  </button>
                </th>
                <th>
                  <span>Author</span>
                  <button type="button" className="sort-btn ms-1" title="Sort by Author"
                    onClick={event => handleSortKey(event, "BookAuthor", sorting.field === "BookAuthor" && sorting.order === "asc" ? "desc" : "asc")}
                    style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', verticalAlign: 'middle' }}>
                    <i className={
                      sorting.field === "BookAuthor"
                        && sorting.order === "asc"
                            ? "fa fa-arrow-up text-primary"
                            : "fa fa-arrow-down text-primary"
                    }
                    style={{ fontSize: '1.1em', opacity: sorting.field === "BookAuthor" ? 1 : 0.7 }}></i>
                  </button>
                </th>
                <th>
                  <span>Call No</span>
                  <button type="button" className="sort-btn ms-1" title="Sort by Call No"
                    onClick={event => handleSortKey(event, "CallNo", sorting.field === "CallNo" && sorting.order === "asc" ? "desc" : "asc")}
                    style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', verticalAlign: 'middle' }}>
      <style>{`
        /* Enhanced responsive header action row for mobile */
        @media (max-width: 900px) {
          .addbooks-header-action-row {
            gap: 0.5rem !important;
          }
        }
        @media (max-width: 767.98px) {
          .addbooks-header-action-row {
            flex-direction: column !important;
            align-items: stretch !important;
            gap: 0.5rem !important;
          }
          .addbooks-header-action-row > div {
            width: 100% !important;
            margin-bottom: 0.5rem !important;
          }
          .addbooks-header-action-btn {
            width: 100% !important;
            margin-bottom: 0.5rem !important;
          }
          .addbooks-header-action-icons {
            width: 100% !important;
            justify-content: flex-end !important;
            margin-bottom: 0 !important;
          }
          .addbooks-header-action-row .flex-grow-1 {
            display: none !important;
          }
        }
        @media (max-width: 600px) {
          .addbooks-header-action-row {
            gap: 0.4rem !important;
          }
          .addbooks-header-action-btn, .addbooks-header-action-icons {
            margin-bottom: 0.3rem !important;
          }
        }
      `}</style>
                    <i className={
                      sorting.field === "CallNo"
                        && sorting.order === "asc"
                            ? "fa fa-arrow-up text-primary"
                            : "fa fa-arrow-down text-primary"
                    }
                    style={{ fontSize: '1.1em', opacity: sorting.field === "CallNo" ? 1 : 0.7 }}></i>
                  </button>
                </th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {searchResult.map((item, index) => {
                // Determine status badge color
                let statusColor = 'secondary';
                if (item.Book_Status === 'Available') statusColor = 'success';
                else if (item.Book_Status === 'Issued') statusColor = 'primary';
                else if (item.Book_Status === 'Lost') statusColor = 'danger';
                else if (item.Book_Status === 'Damaged') statusColor = 'warning';

                return (
                  <tr key={item.Accession_No || index} style={{ fontWeight: 500, fontSize: '1rem' }}>
                    <td style={{ color: '#888', fontWeight: 400 }}>{index + 1}</td>
                    <td style={{  whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={item.Accession_No}>{item.Accession_No}</td>
                    <td style={{ maxWidth: 350, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={item.Book_Title}>{item.Book_Title}</td>
                    <td style={{ maxWidth: 140, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={item.Book_Author}>{item.Book_Author}</td>
                    <td style={{ maxWidth: 100, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={item.Book_Classification_No}>{item.Book_Classification_No}{" "}{item.authorMark}</td>
                    <td>
                      <span className={`badge bg-${statusColor}`} style={{ fontSize: '0.95rem', padding: '6px 12px', borderRadius: '8px', letterSpacing: 0.5 }}>
                        {item.Book_Status}
                      </span>
                    </td>
                    <td  style={{textAlign:'center'}}>
                      <Dropdown as={ButtonGroup} align="end" style={{ alignItems: 'center', horizontalAlign: 'middle' }}>
                        <Dropdown.Toggle as={Button} variant="link" className="action-dropdown-toggle p-0 border-0 bg-transparent" style={{ boxShadow: 'none' }} aria-label="Actions">
                          <span className="icon icon-md" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 36, height: 36, borderRadius: '50%', transition: 'background 0.2s', background: 'none' }}>
                            <i className="fa fa-ellipsis-v" style={{ fontSize: '1.3em', color: '#4f8cff' }}></i>
                          </span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="action-dropdown-menu" style={{ minWidth: 120, borderRadius: 12, boxShadow: '0 4px 16px rgba(44,62,80,0.13)', padding: '0.5rem 0', zIndex: 9999, position: 'absolute', top: '100%', left: 0 }}>
                          <Dropdown.Item onClick={event => { handleShow(event, "View", item) }} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 18px', fontSize: '1rem', borderRadius: 8 }}>
                            <i className="fa fa-eye"></i> View Book
                          </Dropdown.Item>
                          <Dropdown.Item onClick={event => { handleShow(event, "Edit", item) }} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 18px', fontSize: '1rem', borderRadius: 8 }}>
                            <i className="fa fa-pen"></i> Edit Book
                          </Dropdown.Item>
                          <Dropdown.Item onClick={event => { handleShow(event, "Clone", item) }} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 18px', fontSize: '1rem', borderRadius: 8 }}>
                            <i className="fa fa-clone"></i> Clone Book
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        :null}
      </div>
    </div>
    {/* Scroll To Top Icon */}
    {showScrollTop && (
      <button
        onClick={scrollToTop}
        style={{
          position: 'fixed',
          bottom: '40px',
          right: '40px',
          zIndex: 9999,
          background: 'linear-gradient(135deg, #063547 60%, #7ee8fa 100%)',
          color: '#fff',
          border: 'none',
          borderRadius: '50%',
          width: '48px',
          height: '48px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '24px',
          transition: 'background 0.3s',
        }}
        aria-label="Scroll to top"
        title="Scroll to top"
      >
        <i className="fa fa-arrow-up" aria-hidden="true"></i>
      </button>
    )}
    </>
  )
}
